export default __webpack_public_path__ + "static/bfarminer-1579c43d7a3e06f57b3a02ed2a994870.jpg";